module.exports = __webpack_public_path__ + "img/join_4_1.9fdb2b52.jpg";